// ------------------------------------------------------
// Import des composants pour construction d'un build unique
// chargé en une seule fois .
// ------------------------------------------------------
// import Accueil from './components/pages/Accueil.vue'
// import Club from './components/pages/Club.vue'
// import Comite from './components/pages/Comite.vue'
// import EquipeTechnique from './components/pages/EquipeTechnique.vue'
// import Gymnases from './components/pages/Gymnases.vue'
// import Inscriptions from './components/pages/Inscriptions.vue'
// import LiensUtiles from './components/pages/LiensUtiles.vue'
// import Actus from './components/pages/Actus.vue'
// import Actu from './components/pages/Actu.vue'
// import Equipes from './components/pages/Equipes.vue'
// import Equipe from './components/pages/Equipe.vue'
// import MiniBasket from './components/pages/MiniBasket.vue'
// import BabyBasket from './components/pages/BabyBasket.vue'
// import BasketEcole from './components/pages/BasketEcole.vue'
// import Agenda from './components/pages/Agenda.vue'
// import Evenement from './components/pages/Evenement.vue'
// import SportSante from './components/pages/SportSante.vue'
// import BasketSante from './components/pages/BasketSante.vue'
// import SportOrdonnance from './components/pages/SportOrdonnance.vue'
// import Sponsors from './components/pages/Sponsors.vue'
// import DevenirPartenaire from './components/pages/DevenirPartenaire.vue'
// import MecenatDon from './components/pages/MecenatDon.vue'
// import Boutique from './components/pages/Boutique.vue'
// import BoutiqueEnConstruction from './components/pages/BoutiqueEnConstruction.vue'
// import Contact from './components/pages/Contact.vue'
// import MentionsLegales from './components/pages/MentionsLegales.vue'
// import PlanSite from './components/pages/PlanSite.vue'
// import ProtectionDonnees from './components/pages/ProtectionDonnees.vue'
// import CGV from './components/pages/CGV.vue'
// import PolitiqueCookies from './components/pages/PolitiqueCookies.vue'
// import Galeries from './components/pages/Galeries.vue'
// import Galerie from './components/pages/Galerie.vue'
// import Erreur404 from './components/pages/Erreur404.vue'
// import TestComponent from './components/TestComponent.vue'
// import LoginPage from './components/pages/admin/LoginPage.vue'
// import PreviewPage from './components/pages/admin/PreviewPage.vue'


// ------------------------------------------------------
// Import des composants pour lazy-loading des composants
// ------------------------------------------------------
const Accueil = r => require.ensure([], () => r(require('./components/pages/Accueil.vue')))
const Club  = r => require.ensure([], () => r(require('./components/pages/Club.vue')))
const Comite  = r => require.ensure([], () => r(require('./components/pages/Comite.vue')))
const EquipeTechnique  = r => require.ensure([], () => r(require('./components/pages/EquipeTechnique.vue')))
const Gymnases  = r => require.ensure([], () => r(require('./components/pages/Gymnases.vue')))
const Inscriptions  = r => require.ensure([], () => r(require('./components/pages/Inscriptions.vue')))
const LiensUtiles  = r => require.ensure([], () => r(require('./components/pages/LiensUtiles.vue')))
const Actus  = r => require.ensure([], () => r(require('./components/pages/Actus.vue')))
const Actu  = r => require.ensure([], () => r(require('./components/pages/Actu.vue')))
const Equipes  = r => require.ensure([], () => r(require('./components/pages/Equipes.vue')),'equipe-bundle')
const Equipe  = r => require.ensure([], () => r(require('./components/pages/Equipe.vue')),'equipe-bundle')
const MiniBasket  = r => require.ensure([], () => r(require('./components/pages/MiniBasket.vue')))
const BabyBasket  = r => require.ensure([], () => r(require('./components/pages/BabyBasket.vue')))
const BasketEcole  = r => require.ensure([], () => r(require('./components/pages/BasketEcole.vue')))
const Agenda  = r => require.ensure([], () => r(require('./components/pages/Agenda.vue')))
const Evenement  = r => require.ensure([], () => r(require('./components/pages/Evenement.vue')))
const SportSante  = r => require.ensure([], () => r(require('./components/pages/SportSante.vue')))
const BasketSante  = r => require.ensure([], () => r(require('./components/pages/BasketSante.vue')))
const SportOrdonnance  = r => require.ensure([], () => r(require('./components/pages/SportOrdonnance.vue')))
const Sponsors  = r => require.ensure([], () => r(require('./components/pages/Sponsors.vue')))
const DevenirPartenaire  = r => require.ensure([], () => r(require('./components/pages/DevenirPartenaire.vue')))
const MecenatDon  = r => require.ensure([], () => r(require('./components/pages/MecenatDon.vue')))
const Boutique  = r => require.ensure([], () => r(require('./components/pages/Boutique.vue')))
const BoutiqueEnConstruction  = r => require.ensure([], () => r(require('./components/pages/BoutiqueEnConstruction.vue')))
const Contact  = r => require.ensure([], () => r(require('./components/pages/Contact.vue')))
const MentionsLegales  = r => require.ensure([], () => r(require('./components/pages/MentionsLegales.vue')))
const PlanSite  = r => require.ensure([], () => r(require('./components/pages/PlanSite.vue')))
const ProtectionDonnees  = r => require.ensure([], () => r(require('./components/pages/ProtectionDonnees.vue')))
const CGV  = r => require.ensure([], () => r(require('./components/pages/CGV.vue')))
const PolitiqueCookies  = r => require.ensure([], () => r(require('./components/pages/PolitiqueCookies.vue')))
const Galeries  = r => require.ensure([], () => r(require('./components/pages/Galeries.vue')))
const Galerie  = r => require.ensure([], () => r(require('./components/pages/Galerie.vue')))
const Erreur404  = r => require.ensure([], () => r(require('./components/pages/Erreur404.vue')))
const TestComponent  = r => require.ensure([], () => r(require('./components/TestComponent.vue')))
const LoginPage  = r => require.ensure([], () => r(require('./components/pages/admin/LoginPage.vue')))
const PreviewPage  = r => require.ensure([], () => r(require('./components/pages/admin/PreviewPage.vue')))

// -------------
export const routes = [
  { path: '/accueil', name: "accueil", component: Accueil,
    meta: {
      title: 'Accueil | Basket Olympique Puechen',
      metaTags: [
        {
          name: 'description',
          content: `Bienvenue sur le site web du Basket Olympique Puechen!
                    Le BOP (Basket Olympique Puechen) est une association régie par la loi 1901 et affiliée à la Fédération Française de Basket-ball
                    Elle a été créée en 1994 par Raymond Martino avec le but permettre l’épanouissement des jeunes (et des moins jeunes) à travers le sport, dans la joie et la bonne humeur.
                    Depuis ce jour, l’association garde sa dynamique familiale et son ambiance conviviale.`
        },
        {
          property: 'og:description',
          content: `Bienvenue sur le site web du Basket Olympique Puechen! Le BOP (Basket Olympique Puechen) est une association régie par la loi 1901 et affiliée à la Fédération Française de Basket-ball
          Elle a été créée en 1994 par Raymond Martino avec le but permettre l’épanouissement des jeunes (et des moins jeunes) à travers le sport, dans la joie et la bonne humeur.
          Depuis ce jour, l’association garde sa dynamique familiale et son ambiance conviviale.`
        }
      ]
    }
  },
  { path: '/club', name: "club", component: Club,
    meta: {
      title: 'Le Club | Basket Olympique Puechen',
      metaTags: [
        {
          name: 'description',
          content: 'Le BOP (Basket Olympique Puechen) vous présente le club!'
        },
        {
          property: 'og:description',
          content: 'Le BOP (Basket Olympique Puechen) vous présente le club!'
        }
      ]
    }
  },
  { path: '/comite', name: "comite", component: Comite },
  { path: '/equipe-technique', name: "equipe-technique", component: EquipeTechnique },
  { path: '/gymnases', name: "gymnases", component: Gymnases },
  { path: '/inscription-et-licences', name: "inscription", component: Inscriptions },
  { path: '/liens-utiles-et-ressources', name: "ressources", component: LiensUtiles },
  { path: '/actualites', name: "actus", component: Actus },
  { path: '/actualites/:actuId', name: "actuId", component: Actu },
  { path: '/equipes', name: "equipes", component: Equipes,
    meta: {
      title: 'Le Club | Basket Olympique Puechen',
      metaTags: [
        {
          name: 'description',
          content: 'Vivez la passion Basket avec les équipes du BOP (Basket Olympique Puechen)!'
        },
        {
          property: 'og:description',
          content: 'Vivez la passion Basket avec les équipes du BOP (Basket Olympique Puechen)!'
        }
      ]
    }
  },
  { path: '/equipes/:category', name: "equipe", component: Equipe },
  { path: '/mini-basket', name: "mini-basket", component: MiniBasket },
  { path: '/baby-basket', name: "baby-basket", component: BabyBasket },
  { path: '/operation-basket-ecole', name: "obe", component: BasketEcole },
  { path: '/agenda', name: "agenda", component: Agenda },
  { path: '/agenda/:category', name: "eventId", component: Evenement },
  { path: '/sport-sante', name: "sport-sante", component: SportSante },
  { path: '/sport-sante/sport-sur-ordonnance', name: "sport-ordonnance", component: SportOrdonnance },
  { path: '/sport-sante/basket-sante', name: "basket-sante", component: BasketSante },
  { path: '/sponsors', name: "sponsors", component: Sponsors },
  { path: '/partenaires', name: "partenaires", component: Sponsors },
  { path: '/devenir-partenaire', name: "partenariat", component: DevenirPartenaire },
  { path: '/mecenat', name: "mecenat", component: MecenatDon },
  { path: '/boutique', name: "boutique",component: BoutiqueEnConstruction },
  { path: '/contact', name: "contact", component: Contact, children: [
    {
      // UserProfile will be rendered inside User's <router-view>
      // when /user/:id/profile is matched
      path: '*',
      component: Erreur404
    }
  ]  },
  { path: '/galeries', name: "galeries", component: Galeries },
  { path: '/galeries/:id', name: "galerie", component: Galerie },
  { path: '/plan-du-site', name: "plan", component: PlanSite },
  { path: '/mentions-legales', name: "mentions", component: MentionsLegales },
  { path: '/politique-de-confidentialite', name: "rgpd", component: ProtectionDonnees },
  { path: '/conditions-generales-de-vente', name: "cgv", component: CGV },
  { path: '/politique-de-cookies', name: "cookies", component: PolitiqueCookies },
  { path: '/erreur404', name: "error404", component: Erreur404 },
  // { path: '/bop-login', name: "login", component: LoginPage },
  // { path: '/bop-preview', name: "preview", component: PreviewPage },
  { path: '/', redirect:"/accueil" },
  //{ path: '/root', name: "root", component: TestComponent },
  { path: '*', component: Erreur404,
    children: [
      {
        // UserProfile will be rendered inside User's <router-view>
        // when /user/:id/profile is matched
        path: '*',
        component: Erreur404
      }
    ]
  }

  // { path: '*', redirect: "/erreur404" }
];



// WEBPACK FOOTER //
// ./src/routes.js